import { gql } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useUser } from '@tbitop/authentication';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { defaultTo } from 'lodash-es';
import type { NutzerPartnerbetreuerQuery } from './__generated__/NutzerPartnerbetreuerQuery';

export const useNutzerPartnerbetreuerQuery = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const { data, loading, error } = useQuery<NutzerPartnerbetreuerQuery>(
    gql`
      query NutzerPartnerbetreuer {
        nutzerPartnerbetreuer {
          ...NutzerPartnerbetreuer
        }
      }
      fragment NutzerPartnerbetreuer on Mandant {
        anzeigename
        id
        fachlicheIds {
          kundendivision
          name
          wert
        }
      }
    `,
    {
      onError: e => handleWithErrorNotification('Die Partner des Nutzers konnte nicht geladen werden.')(e),
    },
  );

  return {
    data: defaultTo(data?.nutzerPartnerbetreuer, null),
    loading,
    error,
  };
};

export const usePartner = () => {
  const user = useUser();
  const { data: partners, loading: isLoadingPartners } = useNutzerPartnerbetreuerQuery();
  return { partners, isLoadingPartners, currentPartner: user?.selectedPartner };
};
